import { lazy } from 'react'

export const CaloriesImpactV1 = lazy(() => import('./v1/CaloriesImpactV1'))
